import { lazy, Suspense } from "react"
import { CenteredBox, PageLoader, Root } from "src/shared/components"
import PrivateRoute from "../private-route"

import reportAnalyticsRoutes from "./reports-analytics-route"
import productCatalogRoutes from "./product-catalog-routes"
import procurementRoutes from "./procurement-routes"
import inventoryManagementRoutes from "./inventory-management-routes"
import demandSupplyPlanningRoutes from "./demand-supply-planning-routes"
import salesOrdersRoutes from "./sales-orders-routes"
import customerPartnerRoutes from "./customer-partner-routes"
import systemRoutes from "./system-routes"
import accountingRoutes from "./accounting-routes"
import productionRoutes from "./production-routes"
import fulfillmentRoutes from "./fulfillment-routes"
import { ReadableText } from "src/shared/components/readable-text"

const MainLayout = lazy(() => import("src/shared/layouts/main/main-layout"))

const ActivityLogsCreation = lazy(() => import("src/modules/activity-logs-creaction/pages/Home"))
const Dashboard = lazy(() => import("src/modules/dashboard/pages/Home"))
const Notifications = lazy(() => import("src/modules/notifications"))

const appRoutes = {
  path: "app",
  element: (
    <PrivateRoute>
      <Suspense fallback={<PageLoader isLoading />}>
        <MainLayout />
      </Suspense>
    </PrivateRoute>
  ),
  children: [
    {
      path: "",
      element: (
        <Suspense
          fallback={
            <CenteredBox sx={{ height: "100%", position: "relative" }}>
              <PageLoader position="absolute" isLoading height={"100%"} />
            </CenteredBox>
          }
        >
          <Root />
        </Suspense>
      ),
      children: [
        { index: true, element: <Dashboard /> },
        { path: "dashboard", element: <Dashboard /> },
        reportAnalyticsRoutes,
        productCatalogRoutes,
        procurementRoutes,
        productionRoutes,
        inventoryManagementRoutes,
        demandSupplyPlanningRoutes,
        salesOrdersRoutes,
        customerPartnerRoutes,
        systemRoutes,
        accountingRoutes,
        fulfillmentRoutes,
        { path: "activity-logs-creation", element: <ActivityLogsCreation /> },
        {
          path: "notifications",
          element: (
            <ReadableText>
              <Notifications />
            </ReadableText>
          )
        }
      ]
    }
  ]
}

export default appRoutes
